import { render, staticRenderFns } from "./exchange-rate-conversion.vue?vue&type=template&id=55bc5b3a&scoped=true&lang=pug"
import script from "./exchange-rate-conversion.vue?vue&type=script&lang=js"
export * from "./exchange-rate-conversion.vue?vue&type=script&lang=js"
import style0 from "./exchange-rate-conversion.vue?vue&type=style&index=0&id=55bc5b3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc5b3a",
  null
  
)

export default component.exports